import React, { useContext, useEffect, useState } from "react";
import { Box, TextField, Tab, CircularProgress } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { pathJoinUrl } from "@smfa/utils/src";
import RichTextEditor from "./RichTextEditor";
import FileUploadArea from "./common/FileUploadArea";
import { AppContext } from "../context";
import {
  updatePrivacyPolicy,
  getPrivacyPolicy,
} from "../actions/privacypolicy.actions";

const Privacypolicy = () => {
  const [value, setValue] = React.useState("1");
  const { storage } = useContext(AppContext);
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (event, newValue) => {
    setSuccessMsg("");
    setErrorMsg("");
    setLoader(false);
    setValue(newValue);
  };

  const addAboutBanner_default = {
    id: 0,
    banner_image: "",
    banner_image_name: "",
    banner_image_error: false,
    banner_title: "",
    banner_title_maxlenth: 50,
    banner_title_error: false,
  };
  const policy_default = {
    id: 0,
    policy: "",
    policy_error: false,
  };
  const [policyData, setPolicyData] = useState(policy_default);
  const [addAboutBanner, setAboutBanner] = useState(addAboutBanner_default);
  const [deskimage, setDeskImage] = useState("");
  const onImageChange = (event) => {
    setErrorMsg("");

    let custInfo = { ...addAboutBanner };
    if (event.target.files[0]) {
      setDeskImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image = event.target.files[0];
      custInfo.banner_image_name = event.target.files[0].name;
      custInfo.banner_image_error = false;
      setAboutBanner(custInfo);
    }
  };

  useEffect(() => {
    getPrivacyPolicy().then((res) => {
      let locInfo = { ...addAboutBanner };
      if (res.data.status === true) {
        locInfo.id = res.data.data.id;
        locInfo.banner_title = res.data.data.banner_title;
        locInfo.banner_image_name = res.data.data.banner_image;
        setAboutBanner(locInfo);
        if (res.data.data.banner_image !== null) {
          setDeskImage(
            pathJoinUrl(storage[0].imageEndUrl, res.data.data.banner_image),
          );
        }
        setPolicyData({
          ...policyData,
          id: res.data.data.id,
          policy: res.data.data.policy,
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addAboutBannerInfo = (event) => {
    setErrorMsg("");
    let custInfo = { ...addAboutBanner };
    if (event.target.name === "banner_title") {
      if (event.target.value.length <= addAboutBanner.banner_title_maxlenth) {
        custInfo.banner_title = event.target.value;
        custInfo.banner_title_error = false;
      }
    }

    setAboutBanner(custInfo);
  };

  const submitLocation = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    let custInfo = { ...addAboutBanner };
    if (addAboutBanner.banner_title === "") {
      document.getElementById("banner_title").focus();
      custInfo.banner_title_error = true;
      setAboutBanner(custInfo);
      setLoader(false);
      return false;
    } else {
      custInfo.banner_title_error = false;
      setAboutBanner(custInfo);
    }

    let formData = new FormData();
    formData.append("id", addAboutBanner.id);
    formData.append("key", "banner");
    formData.append("banner_image", addAboutBanner.banner_image);
    formData.append("banner_title", addAboutBanner.banner_title);
    updatePrivacyPolicy(formData)
      .then((res1) => {
        if (res1.data.status === true) {
          setSuccessMsg("Updated Successfully!");
          setLoader(false);
          setTimeout(function () {
            setLoader(false);
            setSuccessMsg("");
          }, 3000);
        } else {
          setAboutBanner(addAboutBanner_default);
          setErrorMsg(res1.data.message);
          setLoader(false);
        }
      })
      .catch((error) => {
        setAboutBanner(addAboutBanner_default);
        setLoader(false);
        setErrorMsg("Something went wrong,please try again!");
      });
  };

  const handleChangeck = (e, editor) => {
    setSuccessMsg("");
    setErrorMsg("");

    if (editor !== "") {
      setPolicyData({ ...policyData, policy: editor.getData() });
    } else {
      setPolicyData({ ...policyData, policy: "" });
    }
  };

  const handlePolicySubmit = () => {
    setLoader(true);
    setSuccessMsg("");
    let custInfo = { ...policyData };
    if (policyData.policy === "") {
      custInfo.policy_error = true;
      setPolicyData(custInfo);
      setLoader(false);
      return false;
    } else {
      custInfo.policy_error = false;
      setPolicyData(custInfo);
    }

    let formData = new FormData();
    formData.append("id", policyData.id);
    formData.append("key", "policy");
    formData.append("policy", policyData.policy);

    updatePrivacyPolicy(formData)
      .then((res1) => {
        if (res1.data.status === true) {
          setSuccessMsg("Updated Successfully!");
          setLoader(false);
          setTimeout(function () {
            setLoader(false);
            setSuccessMsg("");
          }, 3000);
        } else {
          setErrorMsg(res1.data.message);
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        setErrorMsg("Something went wrong,please try again!");
      });
  };

  return (
    <>
      <div className="content">
        <div className="body-inner-sec">
          <div className="container-fluid">
            <div className="row">
              <div className="banner-inner-bdy-sec tab-sec-smfa">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Add Banner" value="1" />
                        <Tab label="Privacy Policy" value="2" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <div className="banner-inner-bdy-sec tab-sec-smfa bene-margin-bot">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="about-banner-sec">
                              <div className="form-secs inner-form-secs vali-forms">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 1, width: "25ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    id="banner_title"
                                    label="Title"
                                    variant="standard"
                                    onChange={addAboutBannerInfo}
                                    name="banner_title"
                                    value={addAboutBanner.banner_title}
                                    error={addAboutBanner.banner_title_error}
                                    helperText={` ${
                                      addAboutBanner.banner_title_error === true
                                        ? "Please enter Title!"
                                        : ""
                                    }`}
                                  />

                                  <div className="charcter-sec">
                                    {addAboutBanner.banner_title_maxlenth -
                                      (addAboutBanner.banner_title?.length ??
                                        0) ===
                                    0 ? (
                                      <>
                                        <span
                                          className="char-limit"
                                          style={{ color: "#FF0000" }}
                                        >
                                          Max Character Limit reached{" "}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <p className="max-charact-sec">
                                          Max Characters:&nbsp;
                                          {addAboutBanner.banner_title_maxlenth -
                                            (addAboutBanner.banner_title
                                              ?.length ?? 0)}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-5 banner-uplod-secs">
                            <FileUploadArea
                              title="Add Banner Image"
                              description={
                                <>
                                  Best image Resolution: 1920px X 836px
                                  <br />
                                  Supported files types: JPG, JPEG & PNG
                                </>
                              }
                              previewUrl={deskimage}
                              fileName={addAboutBanner.banner_image_name}
                              onChange={onImageChange}
                              deleteRequest={{
                                resource: "privacy-policy",
                                id: addAboutBanner.id,
                                field: "banner_image",
                              }}
                              onRemove={() => {
                                setDeskImage("");
                                setAboutBanner((previous) => ({
                                  ...previous,
                                  banner_image: "",
                                  banner_image_name: "",
                                }));
                              }}
                              accept=".png,.jpg,.jpeg"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="button-sec"
                              style={{ marginTop: "30px" }}
                            >
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocation();
                                  e.preventDefault();
                                }}
                              >
                                Update
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Banner Updated Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong,please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                      <div className="banner-inner-bdy-sec tab-sec-smfa bene-margin-bot">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="answer-secs">
                              <h2>Privacy Policy</h2>
                              <RichTextEditor
                                data={policyData.policy}
                                onChange={handleChangeck}
                              />

                              <p
                                style={{
                                  marginBottom: "0px",
                                  marginTop: "8px",
                                }}
                              >
                                {policyData.policy_error === true ? (
                                  <span className="ckvalid">
                                    Please enter Details
                                  </span>
                                ) : (
                                  <span
                                    className="ckvalid"
                                    style={{ visibility: "hidden" }}
                                  >
                                    Please enter Details
                                  </span>
                                )}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="button-sec"
                              style={{ marginTop: "30px" }}
                            >
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  handlePolicySubmit();
                                  e.preventDefault();
                                }}
                              >
                                Update
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Banner Updated Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong, please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Privacypolicy;
